import {UserService} from '../user.service';
import {Router} from '@angular/router';


import {map, switchMap, tap, catchError, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as UserActions from './user.actions';
import * as ErrorActions from '../../error/store/error.actions';
import * as AuthActions from '../../auth/store/auth.actions';
import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {createEffect, Actions, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {User} from '../user.model';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class UserEffects {

  actualUser = createEffect(() => this.actions$
    .pipe(
      ofType(UserActions.GET_ACTUAL_USER),
      switchMap(
        () => {
          return this.userService.getUser().pipe(
            map(
              (response: User) => {
                return {
                  type: UserActions.SET_USER,
                  payload: response
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true});

  actualUserByUid = createEffect(() => this.actions$
    .pipe(
      ofType(UserActions.GET_ACTUAL_USER_BY_UID),
      switchMap(
        () => {
          return this.userService.getUserByUid().pipe(
            map(
              (response: User) => {
                return {
                  type: UserActions.SET_USER,
                  payload: response
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  updateUser = createEffect(() => this.actions$
    .pipe(
      ofType(UserActions.CHANGE_USER),
      map(
        (data: {type: string, payload: {id: number, params: any, config: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (payload: {id: number, params: any, config: any}) => {
          return this.userService.changeUser(payload.id, payload.params).pipe(
            map(
              (response: User) => {
                this.notifierService.success('User data has been updated');
                if (payload.config === undefined) {
                  payload.config = {};
                }
                if (payload.config.redirectAfterSave) {
                  this.router.navigate(payload.config.redirectUrl);
                }
                return {
                  type: UserActions.SET_USER,
                  payload: response
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  updateUserPassword = createEffect(() => this.actions$
    .pipe(
      ofType(UserActions.CHANGE_PASSWORD_USER),
      map(
        (data: {type: string, payload: {id: number, password: string, retypedPassword: string}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (payload: {id: number, password: string, retypedPassword: string}) => {
          return this.userService.changeUserPassword(payload.id, payload.password, payload.retypedPassword).pipe(
            tap(
              (response: any) => {
                this.notifierService.success('Password has been updated');
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  registerTrialUser = createEffect(() => this.actions$
    .pipe(
      ofType(UserActions.REGISTER_TRIAL_USER),
      map(
        (data: {type: string, payload: {id: number, email: string, password: string, retypedPassword: string, params: any}}) => {
          return data.payload;
        }
      ),
      switchMap(
        (payload: {id: number, email: string, password: string, retypedPassword: string, params: any}) => {
          return this.userService.registerUserTrial(payload.id, payload.email, payload.password, payload.retypedPassword).pipe(
              mergeMap(
                (response: any) => {
                  this.notifierService.success('Data has been saved correctly');
                  if (payload.params.redirectAfterSave) {
                    if (payload.params.redirectUrl !== undefined) {
                      this.router.navigate(payload.params.redirectUrl);
                    } else {
                      this.router.navigate(['/user/register/type']);
                    }
                  }
                  return [
                    {
                      type: UserActions.SET_USER,
                      payload: response.user
                    }, {
                      type: AuthActions.SET_TOKEN,
                      payload: {
                        token: response.token,
                        exp: response.exp,
                        id: response.id
                      }
                    }
                  ];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private router: Router,
    private notifierService: ToastrService

  ) {}
}
